export const SHINE_PRIVACY_PAGE = 'https://www.shine.fr/privacy';
export const SHINE_TERMS_AND_CONDITIONS_PAGE =
  'https://www.shine.fr/lp/cgu-ep-en-clair';
